export const replaceDuplicateSlashes = (text, replaceWith = '/') => text.replace(/\/+/g, replaceWith)
